import React from "react";
import styled from "styled-components";
import Direction from "./Direction";
import HoverLink from "../../../elements/HoverLink";
import {WideRestrictionIcon} from "../../../restrictions/WideRestrictionIcon";

const RecommendationRowsContainer = styled.div`
    font-size: 22px;
`;

const RecommendationRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 3px;
`;

const StockLinkContainer = styled.div`
    margin-left: 16px;
`;

const StockLink = styled(HoverLink)`
    margin-left: -8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 0;
`;

const Bloomberg = styled.div`
    font-size: 28px;
`;

const CompanyName = styled.div`
    font-size: 12px;
`;

export const RecommendationRows = ({idea, linkClicked}) => {
    const {recommendation} = idea;
    return (
        <RecommendationRowsContainer>
            <RecommendationRow key={recommendation.bloomberg}>
                <Direction direction={recommendation.direction}/>
                <StockLinkContainer>
                    <StockLink onClick={() => linkClicked("STOCK", {
                        orgId: recommendation.orgId,
                        companyName: recommendation.companyName
                    })}
                               to={`/stock/${recommendation.orgId}`}>
                        <Bloomberg>{recommendation.bloomberg}</Bloomberg>
                        <CompanyName>{recommendation.companyName}</CompanyName>
                    </StockLink>
                </StockLinkContainer>
                <WideRestrictionIcon idea={idea}/>
            </RecommendationRow>
        </RecommendationRowsContainer>
    );
};